import { lazy } from "react";
//leagues
export const Leagues = lazy(() =>
  import(/* webpackChunkName: 'Leagues' */ "../components/leagues/index")
);
export const LeagueSettings = lazy(() =>
  import(
    /* webpackChunkName: 'LeagueSettings' */ "../components/leagues/league-settings"
  )
);
export const PublicLeaderBoard = lazy(() =>
  import(
    /* webpackChunkName: 'PublicLeaderBoard' */ "../components/leagues/publicLeaderBoard"
  )
);
export const LeagueLeaderBoard = lazy(() =>
  import(
    /* webpackChunkName: 'LeagueLeaderBoard' */ "../components/leagues/leagueLeaderBoard"
  )
);

export const ViewOthersTeam = lazy(() =>
  import(
    /* webpackChunkName: 'ViewOthersTeam' */ "../components/leagues/otheruserTeam"
  )
);

export const CreateTeam = lazy(() =>
  import(
    /* webpackChunkName: 'CreateTeam' */ "../components/onboarding/create-team"
  )
);
export const ManageTeam = lazy(() =>
  import(
    /* webpackChunkName: 'ManageTeam' */ "../components/manageTeam/manage-team"
  )
);
export const TransferSummary = lazy(() =>
  import(
    /* webpackChunkName: 'TransferSummary' */ "../components/manageTeam/transfer-summary"
  )
);
export const MyTeam = lazy(() =>
  import(/* webpackChunkName: 'MyTeam' */ "../components/manageTeam/my-team")
);
export const SelectCaptain = lazy(() =>
  import(
    /* webpackChunkName: 'SelectCaptain' */ "../components/onboarding/select-captain"
  )
);
export const SaveTeamName = lazy(() =>
  import(
    /* webpackChunkName: 'SaveTeamName' */ "../components/onboarding/save-team-name"
  )
);
export const SaveTeam = lazy(() =>
  import(
    /* webpackChunkName: 'SaveTeam' */ "../components/onboarding/save-team"
  )
);
export const NoMatch = lazy(() =>
  import(/* webpackChunkName: 'NoMatch' */ "../components/noMatch")
);
export const Home = lazy(() =>
  import(/* webpackChunkName: 'Home' */ "../components/home")
);
export const Stats = lazy(() =>
  import(/* webpackChunkName: 'Stats' */ "../components/stats")
);
export const Profile = lazy(() =>
  import(/* webpackChunkName: 'Profile' */ "../components/profile")
);
export const Rules = lazy(() =>
  import(/* webpackChunkName: 'Rules' */ "../components/rules")
);
export const Terms = lazy(() =>
  import(/* webpackChunkName: 'Terms' */ "../components/terms")
);
export const Privacy = lazy(() =>
  import(/* webpackChunkName: 'Privacy' */ "../components/privacy")
);
